var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import curvePoolsMainnet from '../../../../Fct/tokens/curvePools.json';
import curvePoolsArbitrum from '../../../../Fct/tokens/curvePoolsArbitrum.json';
import curvePoolsOptimism from '../../../../Fct/tokens/curvePoolsOptimism.json';
export var votingEscrowContract = [
    {
        value: '0x5f3b5DfEb7B28CDbD7FAba78963EE202a494e2A2',
        address: '0x5f3b5DfEb7B28CDbD7FAba78963EE202a494e2A2',
        name: 'CRV Voting Escrow',
        chainId: 1,
        decimals: 18,
    },
];
var curvePools = curvePoolsMainnet
    .concat(curvePoolsArbitrum)
    .concat(curvePoolsOptimism);
export var ETH_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export var supportedPools = curvePools.map(function (pool) { return ({
    chainId: pool.chainId,
    address: pool.address,
    value: pool.address,
    name: pool.name,
    decimalsList: pool.decimals,
    coins: pool.coins,
    assetTypeName: pool.assetTypeName,
    symbol: pool.symbol,
    implementation: pool.implementation,
    lpTokenAddress: pool.lpTokenAddress,
    gaugeAddress: pool.gaugeAddress,
}); });
export var supportedGauges = curvePools
    .filter(function (pool) { return Boolean(pool.gaugeAddress); })
    .map(function (pool) { return ({
    chainId: pool.chainId,
    address: pool.gaugeAddress,
    value: pool.gaugeAddress,
    name: pool.name,
    symbol: pool.symbol,
}); });
export var getSupportedTokens = function (address, chainId) {
    var _a;
    return (_a = curvePools
        .find(function (pool) { return pool.address === address && pool.chainId === Number(chainId); })) === null || _a === void 0 ? void 0 : _a.coins.map(function (coin, index) { return ({
        value: coin.address,
        name: coin.symbol,
        symbol: coin.symbol,
        decimals: Number(coin.decimals),
        index: String(index),
    }); });
};
export var getAllSupportedTokens = function (chainId) {
    var pools = curvePools.filter(function (pool) { return pool.chainId === Number(chainId); });
    var coins = [];
    pools.forEach(function (pool) {
        var poolCoins = pool.coins.map(function (coin) { return ({
            value: coin.address,
            name: coin.symbol,
            symbol: coin.symbol,
            decimals: Number(coin.decimals),
        }); });
        coins = __spreadArray(__spreadArray([], __read(coins), false), __read(poolCoins), false);
    });
    return coins;
};
export var getSupportedIndexes = function (address, chainId) {
    if (chainId !== '1' && chainId !== '42161')
        return [];
    var pools = (chainId === '1' ? curvePoolsMainnet : curvePoolsArbitrum);
    var pool = pools.find(function (pool) { return pool.address === address; });
    var supporteIndexes = pool === null || pool === void 0 ? void 0 : pool.coins.map(function (coin, index) { return ({
        address: coin.address,
        value: "".concat(index),
        name: coin.symbol,
        symbol: coin.symbol,
        decimals: Number(coin.decimals),
        indexType: pool.indexType,
    }); });
    return supporteIndexes;
};
export var getAllSupportedIndexes = function (chainId) {
    if (chainId !== '1' && chainId !== '42161')
        return [];
    var pools = (chainId === '1' ? curvePoolsMainnet : curvePoolsArbitrum);
    var coins = [];
    pools.forEach(function (pool) {
        var poolCoins = pool.coins.map(function (coin, index) { return ({
            address: coin.address,
            value: "".concat(index),
            name: coin.symbol,
            symbol: coin.symbol,
            decimals: Number(coin.decimals),
        }); });
        coins = __spreadArray(__spreadArray([], __read(coins), false), __read(poolCoins), false);
    });
    return coins;
};
export var getLPTokenFromGauge = function (chainId, gaugeAddress) {
    var _a;
    if (chainId !== '1' && chainId !== '42161')
        return;
    var pools = (chainId === '1' ? curvePoolsMainnet : curvePoolsArbitrum);
    return (_a = pools.find(function (pool) { return pool.gaugeAddress === gaugeAddress; })) === null || _a === void 0 ? void 0 : _a.lpTokenAddress;
};
export var getLPTokenFromPool = function (chainId, mainContractAddress) {
    var _a;
    if (chainId !== '1' && chainId !== '42161')
        return;
    var pools = (chainId === '1' ? curvePoolsMainnet : curvePoolsArbitrum);
    return (_a = pools.find(function (pool) { return pool.address === mainContractAddress; })) === null || _a === void 0 ? void 0 : _a.lpTokenAddress;
};
export var getSupportedCurveTokens = function (chainId, prevAddresses) {
    var coins = [];
    var addressSet = prevAddresses ? prevAddresses : new Set();
    curvePools.forEach(function (pool) {
        if (pool.chainId !== Number(chainId))
            return;
        pool.coins.forEach(function (coin) {
            if (addressSet.has(coin.address))
                return;
            addressSet.add(coin.address);
            coins.push({
                chainId: pool.chainId,
                value: coin.address,
                name: coin.symbol,
                symbol: coin.symbol,
                decimals: Number(coin.decimals),
                address: coin.address,
                type: 'CURVE',
            });
        });
    });
    return coins;
};
